import React from 'react';
import { DrawerCloseButton, DrawerHeader } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function TrayHeader({ title }) {
  return (
    <>
      <DrawerCloseButton />
      <DrawerHeader>
        {title}
      </DrawerHeader>
    </>
  );
}

TrayHeader.propTypes = {
  title: PropTypes.string
};

export default TrayHeader;
